export default {
  data () {},
  methods: {
    getTransactionStatusColor (status) {
      if (status === 'open') return 'warning'
      if (status === 'past due') return 'danger'
      if (status === 'failed') return 'danger'
      if (status === 'expired') return 'disable'
      if (status === 'processing') return 'warning'
      if (status === 'pending approval') return 'warning'
      return 'success'
    },
    getRefreshableStatus (status) {
      if (status === 'success') return false;
      return true;
    },
  }
}
